var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pb-2",attrs:{"justify":"space-between"}},[_c('g-button',{attrs:{"label":"Cancel"},on:{"onclick":_vm.goback}}),_c('h3',{staticClass:"headline white--text"},[_vm._v(_vm._s(_vm.label))]),_c('g-button',{attrs:{"type":"primary","label":"Create","disabled":_vm.disabled},on:{"onclick":_vm.create}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }